<nav class="mobile-bottom-nav"
     *ngIf="tabs.length > 0"
     aria-label="Primary mobile navigation">
  <ul class="mobile-bottom-nav__list">
    <li *ngFor="let tab of tabs; trackBy: trackByLink"
        class="mobile-bottom-nav__item">
      <a [routerLink]="tab.routerLink"
         routerLinkActive="mobile-bottom-nav__link--active"
         #rla="routerLinkActive"
         [attr.aria-current]="rla.isActive ? 'page' : null"
         class="mobile-bottom-nav__link"
         [attr.aria-label]="tab.label">
        <span class="mobile-bottom-nav__icon" aria-hidden="true" [ngSwitch]="tab.icon">
          <img *ngSwitchCase="'home'" class="mobile-bottom-nav__icon-img" src="assets/images/icons/mySchool.png" width="22" height="22" alt="" />
          <img *ngSwitchCase="'clipboard'" class="mobile-bottom-nav__icon-img" src="assets/images/icons/assignments.png" width="22" height="22" alt="" />
          <img *ngSwitchCase="'notes'" class="mobile-bottom-nav__icon-img" src="assets/images/icons/notes.png" width="22" height="22" alt="" />
          <img *ngSwitchCase="'subscription'" class="mobile-bottom-nav__icon-img" src="assets/images/icons/fees.png" width="22" height="22" alt="" />
          <img *ngSwitchCase="'school'" class="mobile-bottom-nav__icon-img" src="assets/images/icons/mySchool.png" width="22" height="22" alt="" />
          <img *ngSwitchCase="'exams'" class="mobile-bottom-nav__icon-img" src="assets/images/icons/exams.png" width="22" height="22" alt="" />
          <svg *ngSwitchCase="'beewiz'" width="22" height="22" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="12 2 21 7 21 17 12 22 3 17 3 7"/>
          </svg>
          <svg *ngSwitchCase="'question-bank'" width="22" height="22" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h12a2 2 0 0 1 2 2v14H6a2 2 0 0 1-2-2V4z"/>
            <path d="M9 9c0-1.1.9-2 2-2s2 .9 2 2-2 1.5-2 3"/>
            <path d="M11 16h.01"/>
          </svg>
          <svg *ngSwitchCase="'learn'" width="22" height="22" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 5h7a3 3 0 0 1 3 3v12a2 2 0 0 0-2-2H3V5z"/>
            <path d="M21 5h-7a3 3 0 0 0-3 3v12a2 2 0 0 1 2-2h8V5z"/>
          </svg>
          <svg *ngSwitchDefault width="22" height="22" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
          </svg>
        </span>
        <span class="mobile-bottom-nav__label">{{ tab.label }}</span>
      </a>
    </li>
  </ul>
</nav>
